<template>
    <div class="echart-chart-block">
        <div :id="chartID" class="chart"></div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import echarts from 'echarts'
import ecTools from '@/echarts/echarts-tools'
import ecThemeDark from '@/echarts/theme/dark.json'

export default {
    props:
    {
        chartID: {
            type: String,
            required: true,
        },
        data: {
            type: Array,
            default: function () { return [] }
        },
        unit: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
        showToolbox: {
            type: Boolean,
            default: true,
        },
        showLegend: {
            type: Boolean,
            default: true,
        },
        theme: {
            type: String,
            default: 'light', // light, dark
        },
    },
    data () {
        return {
            theChart: undefined,
        }
    },
    mounted () {
        if ( this.theme == 'dark' )
        {
            echarts.registerTheme('dark', ecThemeDark)
            this.theChart = echarts.init(document.getElementById( this.chartID ), 'dark');
        }
        else
        {
            this.theChart = echarts.init(document.getElementById( this.chartID ));
        }
        this.drawChartPrepare();
    },
    computed: {
        ...mapState({
            'language': state => state.user.language,
            'screenWidth': state => state.system.screenWidth,
            'contentWidth': state => state.system.contentWidth,
        }),
    },
    watch: {

        // 偵測到 [ 語言 ] 變動就更新圖表
        data ()
        {
            this.drawChartPrepare();
        },

        // 偵測到 [ 語言 ] 變動就更新圖表
        language ()
        {
            this.drawChartPrepare();
        },

        // 偵測到 [ 視窗寬度 ] 變動就更新圖表
        screenWidth (val, oldVal)
        {
            if ( val != oldVal && this.theChart != undefined )
            {
                this.theChart.resize()
            }
        },
        // 偵測到 [ 版面寬度 ] 變動就更新圖表
        contentWidth (val, oldVal)
        {
            if ( val != oldVal && this.theChart != undefined )
            {
                this.theChart.resize()
            }
        },
    },
    methods: {

        drawChartPrepare ()
        {
            // if (this.data && this.data.length > 0) {
                this.drawChart( this.theChart,
                                this.data,
                                this.unit,
                                this.title,
                                this.showToolbox,
                                this.showLegend );
            // }
        },
        
        drawChart ( chart,
                    _data,
                    _unit,
                    _title,
                    _showToolbox,
                    _showLegend )
        {
            let _legendTitle = [];

            if ( _showLegend )
            {
                _data.forEach( _d => {
                    _legendTitle.push( _d.name )
                })
            }

            let _series = _data;

            let option = {
                // toolbox: ecTools.createToolbox( this.chartID, _deviceName + ' ' + _dataTitle + ' - Line Chart', _showToolbox ),
                title: {
                    text: _title + ' 適宜日數統計',
                    // subtext: '纯属虚构',
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ' + _unit + ' ( {d}% )'
                },
                legend: {
                    type: 'scroll',
                    orient: 'vertical',
                    right: 10,
                    top: 20,
                    bottom: 20,
                    data: _legendTitle,
                    // selected: _legendTitle_Selected,
                },
                color: [ _data[0].color, _data[1].color ],
                series: [
                    {
                        name: _title,
                        type: 'pie',
                        radius: '58%',
                        center: ['50%', '55%'],
                        data: _series,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            },
                        },
                    }
                ],
            };
            chart.setOption(option);
        },

    }
    
}
</script>

<style lang="scss" scoped>



</style>
